import { LoadableAfterPaint } from '@confluence/loadable';

export const BlankPageQuickActionsLazy = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlankPageQuickActions" */ '../src/BlankPageQuickActions.tsx'
			)
		).BlankPageQuickActions,
});
